import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	sessions: [],
	errorMessage: null,
	currentSession: {},
};

export default function sessionsReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_SESSIONS_SUCCESS:
			return Object.assign({}, state, {
				sessions: action.sessions,
			});
		case ActionTypes.LOAD_SESSIONS_FAIL:
			return Object.assign({}, state, {
				errorMessage: action.message,
			});
		case ActionTypes.SELECT_SESSION_SUCCESS:
			return Object.assign({}, state, {
				currentSession: action.session,
			});
		case ActionTypes.RESET_CURRENT_SESSION:
			return Object.assign({}, state, {
				currentSession: {},
			});
		default:
			return state;
	}
}
